import React = require('react');
import { TextLinkKind,TextLinkWidget } from '@tableau/widgets';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';

export interface ManageMfaProps {
    serverUser: IServerUserInfo;
    changePasswordUrl: string;
    isDomainFamilyExternal: boolean;
    isDomainFamilyLocal: boolean;
    siteUser: ISiteUserInfo;
    isUserSelf: boolean;
    manageMfaUrl: string;
}

export function ManageMfaUrl(manageMfaProps: ManageMfaProps): JSX.Element {
    return (
        <table>
            <tbody className={UserSettingsStyle.tbody}>
                {!!manageMfaProps.manageMfaUrl && manageMfaProps.siteUser.authenticationProviderId === 'TABID_WITH_MFA' &&
                <tr>
                    <td className={UserSettingsStyle.labelText}></td>
                    <td className="tb-details-value">
                        <div className="tb-margin-top-wide tb-margin-left-wide">
                            <TextLinkWidget href={manageMfaProps.manageMfaUrl} kind={TextLinkKind.Standard} testId='manage-mfa-link'>
                                {Messages.manageMfa()}
                            </TextLinkWidget>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    );
}